import React, { useEffect, useState } from 'react';

// components
import { Card, CardBody, CardHeader, Row, Col, Spinner } from "reactstrap";
import { MapContainer, TileLayer, Polygon, SVGOverlay } from 'react-leaflet'

// style
import "../../../assets/css/map.css";

// helpers
import { showMessage } from "../../../helpers/message.js";

// api
import regional_api from "../../../api/regional_api.js";

export default function RegionalFicha({ history }) {

    const [showLoading, setshowLoading] = useState(false);

    const [list, set_list] = useState([]);

    const loadFicha = () => {
        setshowLoading(true);
        regional_api.getAll().then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                set_list(result.data);
            }
        });
    }

    useEffect(() => {
        loadFicha();
    }, []);

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <Spinner></Spinner>
                    </div>
                </div>
            }
            <div className="content">
                <Card className="mt-4">
                    <CardHeader>
                        <h4 className="titleCard">Regionais</h4>
                    </CardHeader>
                    <CardBody>
                        {list.length > 0 &&
                            <Row>
                                <Col md="12">
                                    <MapContainer center={[-23.5517845, -46.6591195]} zoom={10} style={{ zIndex: "0" }} scrollWheelZoom={true}>
                                        <TileLayer
                                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                            opacity={0.5}
                                        />
                                        {
                                            list.map((m, key) => (
                                                <SVGOverlay key={key} bounds={JSON.parse(m.polygon)}>
                                                    <Polygon positions={JSON.parse(m.polygon)}>
                                                    </Polygon>
                                                    <text x="40%" y={"50%"}>{m.identificacao}</text>
                                                </SVGOverlay>                                                
                                            ))
                                        }
                                    </MapContainer>
                                </Col>
                            </Row>
                        }
                    </CardBody>
                </Card>
            </div>
        </>
    );
}

